<template>
    <div
        :class="{ 'client-list': page === 'services', 'related-links': true }"
        v-if="list"
    >
        <h2 v-if="title" class="title" v-html="title"></h2>
        <ul>
            <li v-for="(item, index) in list" :key="index">
                <Link
                    v-if="item.link"
                    :post_link="item.link"
                    v-html="item.name"
                    :id="`${item.name}-page`"
                ></Link>
                <span v-else v-html="item.name"></span>
            </li>
        </ul>
    </div>
</template>

<script>
// import GetDateTime from '@/utils/GetDateTime';
import Link from "@/components/ui/Link.vue";

export default {
    name: "related-links",

    props: {
        title: {
            type: String,
            default: ""
        },
        list: {
            type: Array,
            default: []
        },
        page: "",
        id: ""
    },

    // methods: {
    //     GetDateTime: GetDateTime,
    // },

    components: {
        Link
    }
    // mounted() {
    //     console.log(this.list)

    // },
};
</script>

<style lang="scss">
.related-links {
    margin: var(--padding-x2) var(--padding);
    padding: var(--padding) 0 var(--padding)
        calc(var(--margin) - var(--padding));
    border-top: var(--border) solid;
    border-bottom: var(--border) solid;

    .title {
        padding: 0 0 var(--padding);
        font-size: var(--large-size);
    }

    ul {
        // display: flex;
        // flex-wrap: wrap;
        column-count: 3;

        li {
            // width: 33.33%;
            padding: 0 0 0.3rem;
        }
    }
}

.related-links.client-list {
    border: none;
    background-color: var(--grey);
    padding: var(--padding-x2);
    margin-inline: 0;

    .title {
        margin-top: 0;
    }
}

@media only screen and (max-width: 767px) {
    .related-links:not(.client-list) {
        margin: var(--padding) 0;
    }

    .related-links {
        ul {
            column-count: 2;
            li {
                // width: 50%;
            }
        }
    }

    .related-links.client-list {
        padding: var(--padding-x2) var(--padding);
        margin-bottom: 45px;
    }
}
</style>
